import { IsNotEmpty } from "class-validator";

import { ScoreDogClassDto } from "./score-dog-class.dto";
import { IScoreDogClassExt } from "./score-dog-class-ext.interface";

export class ScoreDogClassExtDto
  extends ScoreDogClassDto
  implements IScoreDogClassExt
{
  //
  @IsNotEmpty()
  show_id: string;
}
